function roundToN(num, decimals) {
  // Input validation
  if (typeof decimals !== 'number' || decimals < 0) {
    throw new Error('Decimals must be a non-negative number');
  }

  // Handle special cases
  if (!Number.isFinite(num)) return num;

  const multiplier = 10 ** decimals;

  // Handle negative numbers properly
  const sign = num < 0 ? -1 : 1;
  const absNum = Math.abs(num);

  // Add epsilon only when needed (for numbers close to x.xx5)
  const epsilon = Number.EPSILON || 2.220446049250313e-16;
  const adjustedNum = absNum + (absNum * epsilon);

  return sign * Math.round(adjustedNum * multiplier) / multiplier;
}

module.exports = { roundToN }